import {IAugmentedJQuery, IController, IModule, IOnChangesObject} from "angular";
import {changesInneholder} from "../../stoettefunk/angularHjelpemetoder";
import c3 from "c3";
import _ from "lodash";
import {regNavn} from "../../tjenester/tredjepartsTjenestenavn";

require('./c3TodeltPie.scss');

export class C3TodeltPie implements IController {
    static registrerKomponent(angular: IModule) {
        angular
            .component('c3TodeltPie', {
                bindings: {
                    andel: '<',
                    totalt: '<',
                    konfig: '<?',
                    tooltip: '&?',
                },
                controller: C3TodeltPie.forInjisering(),
                template: ''
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$element,
            C3TodeltPie
        ]
    }

    constructor(private $element: IAugmentedJQuery) {
        this.domId = 'c3TodeltPie_'+_.random(1000000);
        $element.attr('id', this.domId);
    }

    andel:number = 0; //settes via bindings/$onChanges
    totalt:number = null; //settes via bindings/$onChanges
    konfig: C3TodeltPieKonfig = {
        ikkePåbegyntBakgrunnsFarge: '#db7b7b',
        ikkePåbegyntBorderFarge: '#db7b7b',
        restFarge: '#fff',
        hovedFarge: '#6a6a6a',
        fullførtFarge: '#71a371',
        interaksjonAktivert: true
    }; //settes via bindings/$onChanges
    tooltip?: (arg: { data: { id: string, value: number }; }) => string; //settes via bindings/$onChanges

    domId:string;

    private pieInstans = null;
    
    $onChanges(endringer: IOnChangesObject) {
        //console.debug('c3TodeltPie.$onChanges', endringer);
        if (changesInneholder(endringer, 'andel')){
            //normalt vil this.andel være oppdatert - men ikke alltid - setter derfor her - usikker på hva regelen egentlig er..
            this.andel = endringer['andel'].currentValue;
            this.c3Generer();
        }
        if (changesInneholder(endringer, 'totalt')){
            this.totalt = endringer['totalt'].currentValue;
            this.c3Generer();
        }
        
        if (changesInneholder(endringer, 'andel')
          || changesInneholder(endringer, 'totalt')
          || changesInneholder(endringer, 'konfig')) {
            this.settBorderFarge()
        }
    }

    $onDestroy() {
        if (_.isNumber(this.konfig.termineringsTimeout))
            //ok å bruke window.setTimeout her fremfor angulars $timeout da c3 uansett ikke er integrert med angular
            window.setTimeout(() => this.terminerPieInstans(), this.konfig.termineringsTimeout);
        else
            this.terminerPieInstans();
    }

    //hjelpemetoder
    
    private c3Generer(){
        //console.debug('c3TodeltPie.c3Generer', this.andel, this.totalt);
        if (this.andel == null || this.totalt == null) return;

        const c3Konfig = this.c3Pie()
        //dersom c3Graf vises på side som initielt lastes vises ikke alltid svg-elementet korrekt
        //det virker som om beregningene gjort av c3.generate er sensitive for om dom-en er fullstendig lastet
        //legger derfor tegningen av grafen inn i en timeout slik at dom er ferdig tegnet før graf legges til
        //dette problemet oppleves kun i chrome..
        window.setTimeout(() => {
            this.terminerPieInstans();
            this.pieInstans = c3.generate(c3Konfig);
        }, 1)
    }

    private c3Pie():any{
        return {
            bindto: '#' + this.domId,
            data: {
                columns: [
                    ['andel', this.andel],
                    ['rest', this.totalt - this.andel],
                ],
                order: null,
                type : 'pie',
                colors: {
                    //andel: totalt-andel == 0 ? '#71a371' : '#a3e0a3',
                    andel: this.totalt - this.andel == 0 ? this.konfig.fullførtFarge : this.konfig.hovedFarge,
                    //rest: andel == 0 ? '#db7b7b' : '#d8adad',
                    rest: this.andel == 0 ? this.konfig.ikkePåbegyntBakgrunnsFarge : this.konfig.restFarge
                }
            },
            size: {
                height: 35,
                width: 35
            },
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            },
            pie: {
                label: {
                    show: false
                }
            },
            legend: {
                show: false
            },
            /*tooltip: {
                format: {
                    value: function (value, ratio, id) {
                        return `${value} av ${totalt}`
                    }
                }
            },*/
            tooltip: {
                show: this.tooltip ? true : false,

                contents: (data, defaultTitleFormat, defaultValueFormat, color) => {
                    return `<div class="c3-todelt-pie-tooltip">${this.tooltip({data: data[0]})}</div>`;
                }
            },
            interaction: {
                enabled: this.konfig.interaksjonAktivert
            }
        }
    }
    
    private settBorderFarge() {
        if (this.andel === 0) {
            this.$element.attr('style', `border: 1px solid ${this.konfig.ikkePåbegyntBorderFarge}`);
        } else if (this.andel === this.totalt) {
            this.$element.attr('style', `border: 1px solid ${this.konfig.fullførtFarge}`);
        } else {
            this.$element.attr('style', `border: 1px solid ${this.konfig.hovedFarge}`);
        }
    }

    private terminerPieInstans(){
        if (!this.pieInstans) return;
        this.pieInstans.destroy();
    }
}

export interface C3TodeltPieKonfig {
    ikkePåbegyntBakgrunnsFarge: string;
    ikkePåbegyntBorderFarge: string;
    restFarge: string;
    hovedFarge: string;
    fullførtFarge: string;
    interaksjonAktivert: boolean;
    /** Dersom angitt: antall millis vi skal vente fra angulars $onDestroy kalles til vi kaller pieInstans.destroy().
     * Kan benyttes feks til å vente med å skjule pie til animasjon er ferdig. */
    termineringsTimeout?:number;
}
